import * as certificationApi from '../../api/kkv'

async function getCertification({ commit }, userCompanyId) {
  const certification = await certificationApi.getKkvCertificationResult(userCompanyId)
  commit('setSelectedCertification', certification)
}

function setSelectedCertification(state, certification) {
  state.selectedCertification = certification
}

const certificationStore = {
  state: { selectedCertification: null },
  actions: {
    getCertification
  },
  mutations: {
    setSelectedCertification
  },
  getters: {
    selectedCertification: state => {
      return state.selectedCertification
    }
  }
}

export default certificationStore
